export default __webpack_public_path__ + "static/1-d92a08977d36ecf50bc383785e47dcc7.jpg";